import { show } from "./utils/helpers";

export default class Banner {

  constructor() {
    const banner = document.querySelectorAll('.main-banner');
    if (banner) {
      this.init();
    }
  }

  init() {
    // Remove banner.
    const bannerClose = document.querySelector('.js-dashboard-banner-close');
    if (bannerClose) {
      bannerClose.addEventListener('click', function(e){

        const img = e.target;
        const id = img.getAttribute('data-id');

        img.parentNode.remove(img);

        const date = new Date();
        date.setFullYear(date.getFullYear() + 1);
        document.cookie = 'banner_remove[' + id + ']=1; expires=' + date.toString();
      });
    }

    // Remove marketplace banner if plan is developer.
    const marketplacePlanName = window.__marketplacePlanName__;
    if (['seller', 'reseller'].indexOf(marketplacePlanName) !== -1) {
      show('#banner_marketplace_reseller');
    }
  }
}
